import {quickSlice} from "../../../../setup/redux/slice/quickSlice";
import {basedApiMock} from "../../../../../_the_law/_helpers/forApiMock";

export const categorySlice = quickSlice({
    name: "categories",
    endpoint: basedApiMock("category", "category"),
});
